import { Divider, Drawer, Space, Select, Tooltip, Input, Button, Collapse, Checkbox, Spin } from "antd";
import React, { useState } from "react";
import { useTemplate } from "../../../utils/Template";
import EditorPanelHeading from "../../UI/EditorPanelHeading";
import { PaddingHorizontalIcon, PaddingVerticalIcon } from "../../Icons";
import MobileSelector from "../../UI/MobileSelector";
import ColourPicker from "../../../globals/styles/ColourPicker";
import { getColor } from "../../../utils/ConvertCSS";
import ButtonPicker from "../../../globals/styles/ButtonPicker";
import Html from "../../../utils/Html";
import LinkPicker from "../../../globals/styles/LinkPicker";
import { PicRightOutlined, PicLeftOutlined, CaretRightOutlined, ArrowUpOutlined, PicCenterOutlined } from '@ant-design/icons';

import { tt_ac_accordion, tt_ac_ghost, tt_ig_padding_x, tt_ig_padding_y, tt_name_block_warning } from "../../../utils/Utils";
import Faqs from "../../UI/Faqs";
import PresetPicker from "../../../globals/styles/PresetPicker";
import BMInput from "../../comps/BMInput";
import SliderInput from "../../UI/SiderInput";

const { Panel } = Collapse;

export default function Accordion(props) {
    const { edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, id = 0, view = "desktop", setView = () => { } } = props;
    const [template,] = useTemplate();
    const [mobile, setMobile] = useState(false)
    const [content, setContent] = useState(props.content);

    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }

    // Component agnostic
    const {
        name = "",
        container = true,
        data = {},
        date_changed = 0
    } = content;

    const {
        label = "FAQ",
        width = 1248,
        has_width = false,
        label_preset = 0,
        header_preset = 0,
        align = "center",
        is_accordion = false,
        is_ghost = false,
        paragraph_background = 0,
        paragraph_preset = 0,
        background_colour = 0,
        arrow_colour = 0,
        arrow_size = 15,
        padding_x = 10,
        padding_y = 10,
        faq = [
            { headline: "Headline", label: "Unnamed", paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tincidunt enim vel lectus egestas hendrerit."},
            { headline: "Headline", label: "Unnamed", paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tincidunt enim vel lectus egestas hendrerit."},
            { headline: "Headline", label: "Unnamed", paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tincidunt enim vel lectus egestas hendrerit."},
        ],
        
        allow_mobile_overrides = false,
        mobile_arrow_size = 15,
        link_id = 0,

    } = data;

    const save = () => {
        if (!name) {
            let _name = prompt(tt_name_block_warning);
            if (_name) {
                close();
                saveItem(id, { ...content, "name": _name });
            } else {
                return;
            }
        } else {
            close();
            saveItem(id, { ...content })
        }
    }

    const trash = () => {
        deleteItem(id);
        close();
    }

    const drawRender = () => {

        const m = (allow_mobile_overrides && view !== "desktop") ? true : false;

        const _style = {
            background: getColor(background_colour, template),
            width: (has_width && !m) ? width + "px" : "100%",
            margin: (align === "center") ? "0 auto" : (align === "right") ? "0 0 0 auto" : "initial",
            padding: `${padding_y}px ${padding_x}px`,
        }

        return (
            <div id={"bm-" + id} className={(container) ? "preview-container" : ""}>
                <div style={_style}>
                    {(label &&
                        <h2 style={{ "display": "block" }} className={"bm-txt-" + label_preset} >
                            {label}
                        </h2>
                    )}
                    <Collapse 
                        style={{ "display": "block" }} 
                        accordion={is_accordion}
                        ghost={is_ghost}
                        className={"antd-accordion"}
                        expandIcon={({ isActive }) => <CaretRightOutlined style={{fontSize: m ? `${mobile_arrow_size}px` : `${arrow_size}px`, color: getColor(arrow_colour, template)}} rotate={isActive ? 90 : 0} />}
                    >
                        {faq.map((item, index) => (
                            <Panel 
                                className={`bm-${is_ghost ? "txt" : "btn"}-${header_preset}`}
                                header={<span>{item.headline}</span>} key={index}
                            >
                                <div style={{background: getColor(paragraph_background, template)}}>
                                    <div className={"bm-txt-" + paragraph_preset}>
                                        <Html anchor={"bm-lnkin-" + link_id} html={item.paragraph} />
                                    </div>
                                </div>
                            </Panel>
                        ))}
                    </Collapse>
                </div>
            </div>
        )
    }

    const drawDesktop = () => {
        return (
            <div>
                {/* LABEL */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LABEL</Divider>
                <Input style={{ "fontSize": "11px" }} onChange={(e) => setData({ ...data, "label": e.target.value })} value={label} placeholder="Label..." />
                <div className="shim" /> <div className="shim" />

                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LABEL PRESET</Divider>
                <PresetPicker value={label_preset} onChange={(e) => setData({ ...data, "label_preset": e })} />

                {/* MAX WIDTH */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">MAX WIDTH</Divider>
                <div className="float-flex">
                <SliderInput
                        width={90}
                        min={500}
                        max={1248}
                        onChange={(_v) => setData({ ...data, "width": _v })}
                        disabled={!has_width}
                        value={width}
                />
                    <Checkbox onChange={(e) => setData({ ...data, "has_width": e.target.checked })} checked={has_width}><small>Constrain?</small></Checkbox>
                </div>
                <div className="shim" /> <div className="shim" />

                <Faqs container={container} paragraph_preset={paragraph_preset} link_id={link_id} extra data={data} setData={setData} faq={faq} />

                {/* ALIGN */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ALIGN</Divider>
                <div className="float-flex">
                    <Space>
                        <div><PicLeftOutlined onClick={() => setData({ ...data, "align": "left" })} style={{ "color": (align === "left") ? "#1890ff" : "#AAA" }} /></div>
                        <div><PicCenterOutlined onClick={() => setData({ ...data, "align": "center" })} style={{ "color": (align === "center") ? "#1890ff" : "#AAA" }} /></div>
                        <div><PicRightOutlined onClick={() => setData({ ...data, "align": "right" })} style={{ "color": (align === "right") ? "#1890ff" : "#AAA" }} /></div>
                    </Space>
                </div>
                <div className="shim" /> <div className="shim" />

                {/* BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={background_colour} onChange={(_v) => setData({ ...data, "background_colour": _v })} />
                <div className="shim" /> <div className="shim" />

                {/* PADDING */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PADDING</Divider>
                <div className="float-flex">
                    <Space>
                        <BMInput value={padding_x} onChange={(_v) => setData({ ...data, "padding_x": _v })} number min={0} max={100} prefix={<Tooltip title={tt_ig_padding_x}><PaddingHorizontalIcon style={{ "color": "#888" }} /></Tooltip>} />
                        <BMInput value={padding_y} onChange={(_v) => setData({ ...data, "padding_y": _v })} number min={0} max={100} prefix={<Tooltip title={tt_ig_padding_y}><PaddingVerticalIcon style={{ "color": "#888" }} /></Tooltip>} />
                    </Space>
                    <div></div>
                </div>
                <div className="shim" /> <div className="shim" />

                <div className="float-flex">
                    <Tooltip title={tt_ac_accordion}>
                        <Checkbox checked={is_accordion} onChange={(e) => setData({ ...data, "is_accordion": e.target.checked })}>
                            <small>Accordion?</small>
                        </Checkbox>
                    </Tooltip>
                </div>
                <div className="shim" /> <div className="shim" />

                <div  className="float-flex">
                    <Tooltip title={tt_ac_ghost}>
                        <Checkbox
                            checked={is_ghost}
                            onChange={(e) => setData({
                                ...data,
                                is_ghost: e.target.checked,
                                paragraph_background: e.target.checked ? 0 : data.paragraph_background,
                                header_preset: 0
                            })}
                        >
                            <small>Ghost?</small>
                        </Checkbox>
                    </Tooltip>

                </div>
                <div className="shim" /> <div className="shim" />

                {
                    is_ghost ? (
                        <>
                            <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEADER PRESET</Divider>
                            <PresetPicker value={header_preset} onChange={(e) => setData({ ...data, "header_preset": e })} />
                            <div className="shim" /> <div className="shim" />
                        </>
                    ) : (
                        <>
                            <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEADER PRESET</Divider>
                            <ButtonPicker value={header_preset} onChange={(e) => setData({ ...data, "header_preset": e })} />
                            <div className="shim" /> <div className="shim" />
                        </>
                    )
                }



                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PARAGRAPH PRESET</Divider>
                <PresetPicker value={paragraph_preset} onChange={(e) => setData({ ...data, "paragraph_preset": e })} />
                <div className="shim" /> <div className="shim" />

                {/* PARAGRAPH COLOUR */}

                {!is_ghost ? (
                    <>
                        <Divider orientationMargin={0} orientation="left" plain className="simple-divider">
                            PARAGRAPH BACKGROUND COLOUR
                        </Divider>
                        <ColourPicker
                            allow_gradient
                            allow_none
                            value={paragraph_background}
                            onChange={(_v) => setData({ ...data, "paragraph_background": _v })}
                        />
                        <div className="shim" /> <div className="shim" />
                    </>
                ) : null}


                {/* ARROW */}   
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ARROW SIZE</Divider>
                <div className="float-flex">
                <SliderInput
                        width={90}
                        min={10}
                        max={50}
                        onChange={(_v) => setData({ ...data, "arrow_size": _v })}
                        value={arrow_size}
                />
                </div>
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ARROW COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={arrow_colour} onChange={(_v) => setData({ ...data, "arrow_colour": _v })} />
                <div className="shim" /> <div className="shim" />

                {/* LINK STYLE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LINK STYLE</Divider>
                <LinkPicker value={link_id} onChange={(e) => setData({ ...data, "link_id": e })} />
                <div className="shim" /> <div className="shim" />

            </div>
        )
    }

    const drawMobile = () => {
        return (
            <div>
                <Checkbox onChange={(e) => setData({ ...data, "allow_mobile_overrides": e.target.checked })} checked={allow_mobile_overrides}><small>Enable Overides?</small></Checkbox>
                <div className="shim" /><div className="shim" />

                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ARROW SIZE</Divider>
                <div className="float-flex">
                <SliderInput
                        width={90}
                        min={10}
                        max={50}
                        onChange={(_v) => setData({ ...data, "mobile_arrow_size": _v })}
                        value={mobile_arrow_size}
                />
                </div>
            </div>
        )
    }   

    const drawForm = () => {
        return (
            <>
                <EditorPanelHeading menus={props.menus} close={close} trash={trash} save={save} content={content} setContent={setContent} date_changed={date_changed} name={name} />
                <MobileSelector setView={setView} onChange={(e) => setMobile(e)} />
                <div className="shim" /><div className="shim" />
                {(mobile && drawMobile())}
                {(!mobile && drawDesktop())}
            </>
        )
    }

    
    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX": "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )
}